export default {"src":"/_next/static/media/information_icon.55fc6c8b.svg","height":12,"width":4,"blurWidth":0,"blurHeight":0};